export const getEmilieRomagneData = () => ({
  name: "Émilie-Romagne",
  country: "Italie",
  description: "L'Émilie-Romagne est une région viticole importante du nord de l'Italie, s'étendant de la plaine du Pô aux Apennins. Cette région produit une grande variété de vins, des vins effervescents légers aux vins rouges structurés, avec une forte identité locale.",
  type: "region",
  mapAreas: [
    { region: "Émilie-Romagne", x: 52, y: 43, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "58,000 ha",
    production: "6.8 million hectolitres",
    appellations: "21 DOC et 2 DOCG",
    provinces: "9 provinces",
    exportPercentage: "35%"
  },
  characteristics: {
    climate: "Climat continental tempéré avec influence méditerranéenne",
    soil: "Sols de calcaire, argile et sable, très fertiles",
    viticulture: "Viticulture traditionnelle et moderne, cépages autochtones"
  },
  wineStyles: {
    red: "Vins rouges fruités et équilibrés, du léger au structuré",
    white: "Vins blancs secs et aromatiques, frais et complexes",
    rose: "Rosés fruités et équilibrés, parfaits pour l'apéritif",
    sparkling: "Lambrusco et vins effervescents légers"
  },
  history: "La viticulture dans l'Émilie-Romagne remonte à l'époque étrusque et romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XIXe siècle a vu l'émergence des appellations. Aujourd'hui, l'Émilie-Romagne est reconnue pour ses vins de qualité et ses cépages autochtones.",
  foodPairing: "Cuisine émilienne, charcuteries, fromages, pâtes, cuisine traditionnelle",
  subregions: {
    "modena": {
      name: "Modena",
      description: "Région de Modena produisant principalement du Lambrusco, des vins effervescents légers et fruités.",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols de calcaire et d'argile",
        viticulture: "Viticulture traditionnelle, méthode charmat"
      },
      grapeVarieties: {
        red: ["Lambrusco di Sorbara", "Lambrusco Grasparossa", "Lambrusco Salamino"],
        white: ["Pignoletto", "Trebbiano"]
      },
      wineStyles: {
        "lambrusco-modena": "Vins effervescents rouges légers et fruités",
        "pignoletto-modena": "Vins blancs secs et aromatiques"
      },
      foodPairing: "Charcuteries, fromages, pâtes, cuisine émilienne"
    },
    "bologna": {
      name: "Bologne",
      description: "Région de Bologne produisant des vins rouges et blancs de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols de calcaire et d'argile",
        viticulture: "Viticulture traditionnelle, rendements limités"
      },
      grapeVarieties: {
        red: ["Sangiovese", "Barbera", "Cabernet Sauvignon"],
        white: ["Pignoletto", "Albana", "Trebbiano"]
      },
      wineStyles: {
        "sangiovese-bologna": "Vins rouges fruités et équilibrés",
        "pignoletto-bologna": "Vins blancs secs et aromatiques"
      },
      foodPairing: "Viandes rouges, fromages, pâtes, cuisine traditionnelle"
    },
    "parma": {
      name: "Parme",
      description: "Région de Parme produisant des vins rouges et blancs de qualité, avec une forte identité gastronomique.",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols de calcaire et d'argile",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Barbera", "Bonarda", "Malvasia di Candia"],
        white: ["Malvasia di Candia", "Trebbiano"]
      },
      wineStyles: {
        "barbera-parma": "Vins rouges fruités et équilibrés",
        "malvasia-parma": "Vins blancs secs et aromatiques"
      },
      foodPairing: "Jambon de Parme, fromages, pâtes, cuisine traditionnelle"
    },
    "romagne": {
      name: "Romagne",
      description: "Région de Romagne produisant des vins rouges et blancs de qualité, avec une forte identité méditerranéenne.",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Sols de calcaire et d'argile",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Sangiovese", "Albana", "Trebbiano"],
        white: ["Albana", "Trebbiano", "Pignoletto"]
      },
      wineStyles: {
        "sangiovese-romagne": "Vins rouges fruités et structurés",
        "albana-romagne": "Vins blancs secs et aromatiques"
      },
      foodPairing: "Viandes rouges, poissons, fromages, cuisine méditerranéenne"
    }
  }
}); 